/**
 * Favourites page — reveals the cards a shopper has hearted.
 *
 * The grid arrives fully rendered but hidden, because favourites live in
 * localStorage and Liquid cannot read them. Reacting to `ch:favourites-change`
 * means un-hearting an item on this page removes it immediately.
 */

const FAVOURITES_KEY = 'ch:favourites';

function readFavourites() {
  try {
    const raw = localStorage.getItem(FAVOURITES_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

function render() {
  const root = document.querySelector('[data-cf-root]');
  if (!root) return;

  const saved = new Set(readFavourites());
  const items = Array.from(root.querySelectorAll('[data-cf-item]'));
  let shown = 0;

  for (const item of items) {
    const isSaved = saved.has(String(item.dataset.cfItem));
    item.hidden = !isSaved;
    if (isSaved) shown += 1;
  }

  const gridWrap = root.querySelector('[data-cf-grid-wrap]');
  const empty = root.querySelector('[data-cf-empty]');
  const count = root.querySelector('[data-cf-count]');

  if (gridWrap) gridWrap.hidden = shown === 0;
  if (empty) empty.hidden = shown > 0;
  if (count) {
    count.hidden = shown === 0;
    count.textContent = shown === 1 ? '1 saved item' : `${shown} saved items`;
  }

  // A favourite saved before this pool was rendered — or since removed from the
  // collection — cannot be shown. Say so rather than silently losing it.
  const missing = saved.size - shown;
  if (missing > 0 && count && shown > 0) {
    count.textContent += ` · ${missing} not shown`;
  }
}

document.addEventListener('ch:favourites-change', render);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', render);
} else {
  render();
}
